import React from "react";
import PopUp from "../../HOC/PopUp";
import { FETCHING_MERCHANT_PAYMENT_DATA_BEGINS } from "../../../Constants/DispctaherActionTypeNamesConstant";
import { useDispatch } from "react-redux";

const PosValidationModal = (props) => {
  const actionName =
    process.env.REACT_APP_PG_CONTROLLER +
    "pinepg/v2/session/expires?token=" +
    encodeURIComponent(props.token);
  const onClickSessionSubmit = (event) => {
    event.preventDefault();
    props.resetPopUp();
  };
  return (
    <PopUp isContinueButtonToBeHide="true">
      <>
        <div class="modal-body clearfix">
          <div class="col-12 cardeligibilityfailuremsg">
            <img src="images/warning.png" alt="not eligible" />
            <p class="text-black mt-3 mb-2">{props.errorMessage}</p>
          </div>
          <form id="SessionExpiresForm" method="post" action={actionName}>
            <div class="col-12">
              <input
                type="submit"
                className="btn btn-green"
                id="onSessionSubmit"
                name="onSessionSubmit"
                value="Retry Again"
                onClick={onClickSessionSubmit}
              />
            </div>
          </form>
        </div>
      </>
    </PopUp>
  );
};

export default PosValidationModal;
